import { IsDefined, IsNotEmpty } from 'class-validator';

import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { EntityModel } from 'src/core/services/data/models';
import { ContextService } from 'src/core/services/context.service';

export class DocumentTemplateDataService extends DataService<typeof Model.General.Logic.ViewModels.DocumentTemplateItem, Model.General.Logic.ViewModels.DocumentTemplateItem, IDocumentTemplateItem> {
	private id: number = 0;
	private getNextId(): number {
		this.id--;
		return this.id;
	}

	protected map(entity: Model.General.Logic.ViewModels.DocumentTemplateItem): IDocumentTemplateItem {
		return new DocumentTemplateItemModel(entity);
	}

	public static make(context?: ContextService): DocumentTemplateDataService {
		return new DocumentTemplateDataService(context, ctx => ctx.DocumentTemplates);
	}

	add(defaultLanguage: string, isDocument: boolean): Model.General.Logic.ViewModels.DocumentTemplateItem {
		const entity = new Model.General.Logic.ViewModels.DocumentTemplateItem();
		(entity as any).dynamicProperties = {
			displayName: { [defaultLanguage]: '' },
			translations: { [defaultLanguage]: '' },
		};
		entity.isDocument = isDocument;
		if (!isDocument) {
			(entity as any).dynamicProperties.reactComponent = null;
		}

		return entity;
	}
}

export class DocumentTemplateItemModel extends EntityModel<Model.General.Logic.ViewModels.DocumentTemplateItem, IDocumentTemplateItem> implements IDocumentTemplateItem {
	@property<DocumentTemplateItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<DocumentTemplateItemModel>(o => o.entity.file, (o, value) => o.entity.file = value)
	public file: any;

	@property<DocumentTemplateItemModel>(o => o.entity.isDocument, (o, value) => o.entity.isDocument = value)
	public isDocument: boolean;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: { [prop: string]: any }

	@property<DocumentTemplateItemModel>(o => o.entity.documentService, (o, value) => o.entity.documentService = value)
	public documentService: string;

	@IsNotEmpty({ message: 'Category is required' })
	@IsDefined({ message: 'Category is required' })
	@property<DocumentTemplateItemModel>(o => o.entity.categoryId, (o, value) => o.entity.categoryId = value)
	public categoryId: number;

	@property<DocumentTemplateItemModel>(o => o.entity.category, (o, value) => o.entity.category = value)
	public category: IDocumentTemplateCategorySummary;
	
	@property<DocumentTemplateItemModel>(o => o.entity.customTemplates, (o, value) => o.entity.customTemplates = value)
	public customTemplates: ICustomDocumentTemplateSummary[];

	@property<DocumentTemplateItemModel>(o => o.entity.brands, (o, value) => o.entity.brands = value)
	public brands: DocumentTemplateBrandItem[];

	@property<DocumentTemplateItemModel>(o => o.entity.markets, (o, value) => o.entity.markets = value)
	public markets: DocumentTemplateMarketItem[];
}



// WEBPACK FOOTER //
// ./src/app/general/document-templates/form/document-template-form.data.ts